module.exports = __webpack_public_path__ + "static/img/banner-download@3x.c09f9e0.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/banner-download@3x.png
// module id = 164
// module chunks = 46